var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"white elevation-3 ma-4 fixed-header"},[_c('templates-toolbar'),_c('templates-list',{ref:"templateList"}),_c('template-edit-popup',{on:{"saved":function($event){return _vm.updateList()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }